'use client'

import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { classMerge } from '@components/utilities/classMerge'
import { faHospital } from '@fortawesome/pro-regular-svg-icons'
import { useEffect, useState } from 'react'
import getSponsorProfileImageIdAction from './getSponsorProfileImageIdAction'

export const SponsorProfileImage = ({
  className,
  fallback = true,
  sponsorName,
}: {
  className?: string
  fallback?: boolean
  sponsorName: string
}) => {
  const [sponsorImageId, setSponsorImageId] = useState<string>()

  useEffect(() => {
    const getImage = async () => {
      const result = await getSponsorProfileImageIdAction(sponsorName)
      if (result.success) {
        setSponsorImageId(result.value.sponsorImageId)
      }
    }
    getImage()
  }, [sponsorName])

  if (!sponsorImageId) {
    if (fallback) {
      return (
        <div className='flex size-24 items-center justify-center rounded-full bg-primary50 text-primary500'>
          <Icon icon={faHospital} size='xl' />
        </div>
      )
    }
    return null
  }

  return (
    <CloudflareImage
      alt={`${sponsorName} logo`}
      className={classMerge(
        'relative max-h-full w-full rounded-lg object-contain',
        className,
      )}
      fit='contain'
      height={200}
      imageId={sponsorImageId}
      width={200}
    />
  )
}
